export const SAVED_VIEW_UPDATE = 'SAVED_VIEW_UPDATE';

export const SAVED_VIEW_UI_CONFIG_SET = 'SAVED_VIEW_UI_CONFIG_SET';
export const SAVED_VIEW_DELETE_FROM_STATE = 'SAVED_VIEW_DELETE_FROM_STATE';
export const SAVED_VIEW_CURRENT_SET = 'SAVED_VIEW_CURRENT_SET';

export const SAVED_VIEWS_LIST_SET = 'SAVED_VIEWS_LIST_SET';
export const SAVED_VIEW_UPSERT = 'SAVED_VIEW_UPSERT';
export const SAVED_VIEWS_HYDRATE = 'SAVED_VIEWS_HYDRATE';
